import { MaterialIcons } from '@iclinic/design-system';
import React from 'react';

const PixIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.64519 6.68885C7.03106 6.68782 7.4133 6.76329 7.76982 6.91087C8.12634 7.05846 8.45008 7.27526 8.72231 7.54872L11.7328 10.5598C11.8374 10.6641 11.9792 10.7227 12.1269 10.7227C12.2747 10.7227 12.4164 10.6641 12.5211 10.5598L15.5208 7.56012C15.7928 7.28632 16.1165 7.06926 16.473 6.92155C16.8296 6.77383 17.2119 6.6984 17.5979 6.69963H17.9591L14.1495 2.89013C13.8674 2.60793 13.5325 2.38407 13.1639 2.23134C12.7953 2.07861 12.4002 2 12.0011 2C11.6021 2 11.207 2.07861 10.8384 2.23134C10.4698 2.38407 10.1348 2.60793 9.85274 2.89013L6.05716 6.68885H6.64519ZM17.5979 17.2989C17.2122 17.3003 16.83 17.2253 16.4735 17.0781C16.117 16.931 15.7932 16.7146 15.5208 16.4416L12.5204 13.4394C12.4143 13.3379 12.2731 13.2812 12.1263 13.2812C11.9795 13.2812 11.8383 13.3379 11.7322 13.4394L8.72167 16.4498C8.44942 16.7233 8.12568 16.94 7.76917 17.0876C7.41265 17.2352 7.03042 17.3107 6.64456 17.3097H6.05716L9.85908 21.1116C10.4293 21.6806 11.2019 22.0001 12.0075 22.0001C12.813 22.0001 13.5857 21.6806 14.1559 21.1116L17.9654 17.3015L17.5979 17.2989ZM18.8078 7.54911L21.1099 9.85116V9.85052C21.3921 10.1326 21.6159 10.4675 21.7687 10.8362C21.9214 11.2048 22 11.5999 22 11.9989C22 12.3979 21.9214 12.793 21.7687 13.1617C21.6159 13.5303 21.3921 13.8652 21.1099 14.1473L18.8078 16.4493C18.7559 16.428 18.7004 16.4168 18.6443 16.4164H17.5975C17.0528 16.415 16.5306 16.1987 16.1446 15.8144L13.1449 12.8154C12.6012 12.2717 11.6526 12.2717 11.1083 12.8154L8.09781 15.8258C7.7118 16.2103 7.18965 16.4268 6.64485 16.4284H5.35473C5.30173 16.4293 5.24933 16.4398 5.20012 16.4595L2.88856 14.1479C2.31956 13.5777 2 12.8051 2 11.9995C2 11.194 2.31956 10.4214 2.88856 9.85116L5.20519 7.53897C5.25451 7.55832 5.30684 7.56883 5.3598 7.57002H6.64485C7.18966 7.57155 7.71184 7.78812 8.09781 8.17262L11.1089 11.1818C11.3791 11.4515 11.7452 11.6029 12.1269 11.6029C12.5086 11.6029 12.8747 11.4515 13.1449 11.1818L16.1446 8.18403C16.5306 7.79976 17.0528 7.58343 17.5975 7.58206H18.6443C18.7004 7.58151 18.7559 7.57033 18.8078 7.54911Z"
      fill="#607D8B"
    />
  </svg>
);

const { ListAlt, AttachMoney, CachedRounded } = MaterialIcons;

export const getIcon = (acronym: string) => {
  const icons: { [key: string]: JSX.Element } = {
    px: <PixIcon />,
    bs: <ListAlt />,
    bt: <CachedRounded />,
  };
  if (Object.keys(icons).includes(acronym)) return icons[acronym];
  return <AttachMoney />;
};

export const getPaymentMethod = (acronym: string) => {
  const methods: { [key: string]: string } = {
    ca: 'Dinheiro',
    cc: 'Cartão de crédito',
    dc: 'Cartão de débito',
    bc: 'Cheque',
    bs: 'Boleto',
    bt: 'Transferência bancária',
    px: 'PIX',
    pp: 'PicPay',
  };
  return methods?.[acronym] || 'Dinheiro';
};
